import { ColorPalette } from '../base/colorPalette';

export const ThemeColors = {
	// Primary Palette
	primary: 'var(--epods--color-bg-primary)',

	// Accent Palette
	accent: ColorPalette.blueGrey,

	// Alert Palette
	negative: ColorPalette.deepOrange,

	// Warning Palette
	warning: ColorPalette.amber,

	// Success Palette
	positive: ColorPalette.lightGreen,

	// Monochrome Palette
	white: ColorPalette.white,
	mono100: ColorPalette.grey100,
	mono200: ColorPalette.grey200,
	mono300: ColorPalette.grey300,
	mono400: ColorPalette.grey400,
	mono500: ColorPalette.grey500,
	mono600: ColorPalette.grey600,
	mono700: ColorPalette.grey700,
	mono800: ColorPalette.grey800,
	mono900: ColorPalette.grey900,
	mono1000: ColorPalette.grey1000,
	black: ColorPalette.white,
};
